import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";

export class depotListCtrl implements IController {

  queryString: any;
  depotIds: any;
  doReload: any;
  onReload: Function;
  onRemove: Function;
  onSelect: Function;

  private depotsRef: any;
  private loadLimit: any;
  private infiniteScroll: any;
  private isScrollable: boolean;

  /* @ngInject */
  constructor(private $depots, private $infiniteScroll, private $log, private $mdMedia) {
    this.depotsRef = this.$depots();
  }

  $onInit() {
    this.loadLimit = 30;
    this.depotsRef.$query(this._getDepotsQuery());
    this.infiniteScroll = this.$infiniteScroll(this.depotsRef, this.loadLimit);
    this.isScrollable = !this.$mdMedia('gt-md');
  }

  $onChanges(changes) {
    if (changes.doReload && !changes.doReload.isFirstChange()) {
      if (this.doReload) {
        this._loadDepots();
      }
    }

    if (changes.depotIds && !changes.depotIds.isFirstChange()) {
      this._loadDepots();
    }

    if (changes.queryString && !changes.queryString.isFirstChange()) {
      this._loadDepots();
    }
  };

  $doCheck() {
    this.isScrollable = !this.$mdMedia('gt-md');
  };

  onClick(depot) {
    if (this.onSelect && _.isFunction(this.onSelect)) {
      this.onSelect({depot: depot});
    }
  }

  // ******************************
  //        Private methods
  // ******************************

  private _loadDepots() {
    this.depotsRef.$query(this._getDepotsQuery())
      .then(() => {
        this.infiniteScroll.reload();
        this.onReload();
      })
      .catch((error) => {
        this.$log.error('Failed to load depots @depotList@_loadDepots', error)
      })
  }

  private _getDepotsQuery() {
    return {
      query: this.queryString,
      ids: this.depotIds,
      limit: this.loadLimit
    }
  }


}

angular
  .module('bringoz.admin.depots')
  .component('depotTable', {
    bindings: {
      queryString: '<?',
      depotIds: '<?',
      doReload: '<',
      onReload: '&',
      onRemove: '&',
      onSelect: '&?'
    },
    template: require('./depot-table.html').default,
    controller: depotListCtrl
  });
